import * as React from "react";
import * as ReactDOM from "react-dom";
import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import { IS_PROD, IS_STAGING } from './constants'

import * as Sentry from "@sentry/react";

import App from "./components/App";

import "./styles.less";
import "office-ui-fabric-react/dist/css/fabric.min.css";

initializeIcons();

let isOfficeInitialized = false;

const title = "SimpleLegal";

let savedMatters = [];
let isItemChanged = false;

declare global {
  interface Window {
    isOutlookAddin: boolean;
  }
}

if (IS_PROD || IS_STAGING) {
  Sentry.init({
    dsn: "https://4e6857d5276d4ce585fdea7f2717dc53@o153798.ingest.sentry.io/6171117",
    release: 'version_5',
    ignoreErrors: ["ResizeObserver loop limit exceeded"]
  });
}

const render = (Component) => {
  ReactDOM.render(
    <Component
      title={title}
      isOfficeInitialized={isOfficeInitialized}
      savedMatters={savedMatters}
      isItemChanged={isItemChanged}
      isLoggedIn={false}
    />,
    document.getElementById("container")
  );
};

const itemChanged = (_eventArgs) => {
  isItemChanged = true;

  if (Office.context && Office.context.mailbox && Office.context.mailbox.item) {
    let item = Office.context.mailbox.item;
    item.loadCustomPropertiesAsync((asyncResult) => {
      let customProps = asyncResult.value;
      let aconexProps = customProps.get("SavedMatters");
      savedMatters = typeof aconexProps !== "undefined" ? aconexProps : [];
      render(App);
    });
  } else {
    console.warn('Office.context.mailbox is not available in itemChanged callback.');
    render(App);
  }
};

// Initialize application after Office is ready
Office.onReady(() => {
  isOfficeInitialized = true;

  if (Office.context && Office.context.ui && Office.context.ui.messageParent) {
    try {
      Office.context.ui.messageParent(window.location.href);
    } catch (error) {
      console.warn('Failed to call Office.context.ui.messageParent:', error);
    }
  }

  // Check if running in Outlook context
  if (Office.context && Office.context.mailbox && Office.context.mailbox.item) {
    let item = Office.context.mailbox.item;
    item.loadCustomPropertiesAsync((asyncResult) => {
      let customProps = asyncResult.value;
      let matters = customProps.get("SavedMatters");

      if (typeof matters !== "undefined") {
        savedMatters = matters;
      }

      render(App);
    });

    // Set up item change handler if available
    if (typeof Office.context.mailbox.addHandlerAsync !== "undefined") {
      Office.context.mailbox.addHandlerAsync(
        Office.EventType.ItemChanged,
        itemChanged
      );
    }
  } else {
    // Running outside Outlook context (development mode)
    console.warn('Office.context.mailbox is not available. Running in development mode or outside Outlook context.');
    render(App);
  }
});
